import React from 'react'
import { ColumnMapping, EntityStatus, ExtendedTradingEntityType, SpreadsheetMapping } from 'api'
import { EntityStatusHelper, TradingEntityTypeHelper } from 'model'
import { TradingEntitySpreadsheetParseResult } from './parseTradingEntitySpreadsheet'
import { Locale, Translation } from 'locale'
import {
  ColumnMappingEnumPanel,
  ColumnMappingStringPanel,
  ColumnsContainer,
  ColumnsHeader,
  ColumnsHeaderPanel
} from '../upload/mappingDialog'

export interface TradingEntityMappingDialogColumnsProps {
  mapping: SpreadsheetMapping
  parseResult: TradingEntitySpreadsheetParseResult
  onUpdate: (mapping: SpreadsheetMapping) => unknown
}

export const TradingEntityMappingDialogColumns: React.FC<TradingEntityMappingDialogColumnsProps> = props => {
  const { mapping, parseResult, onUpdate } = props

  const handleColumnUpdate = (columnMapping: ColumnMapping, fieldName: keyof SpreadsheetMapping) =>
    onUpdate({ ...mapping, [fieldName]: columnMapping })

  return (
    <ColumnsContainer>
      <ColumnsHeaderPanel>
        <ColumnsHeader>{Locale.translate(Translation.TC_TRADING_ENTITY_FIELD)}</ColumnsHeader>
        <ColumnsHeader>{Locale.translate(Translation.TC_SPREADSHEET_COLUMN)}</ColumnsHeader>
      </ColumnsHeaderPanel>

      <ColumnMappingStringPanel
        fieldTitle={Locale.translate(Translation.TC_ORGANISATION)}
        fieldName="organisation"
        columnMapping={mapping.organisation}
        parseResult={parseResult}
        onUpdate={handleColumnUpdate}
      />
      <ColumnMappingStringPanel
        fieldTitle={Locale.translate(Translation.TC_PUBLISHED_NAME)}
        fieldName="publishedName"
        columnMapping={mapping.publishedName}
        parseResult={parseResult}
        onUpdate={handleColumnUpdate}
      />
      <ColumnMappingStringPanel
        fieldTitle={Locale.translate(Translation.TC_SHORT_NAME)}
        fieldName="shortName"
        columnMapping={mapping.shortName}
        parseResult={parseResult}
        onUpdate={handleColumnUpdate}
      />

      <ColumnMappingStringPanel
        fieldTitle={Locale.translate(Translation.SC_FICC_SHORT_NAME)}
        fieldName="ficcShortName"
        columnMapping={mapping.ficcShortName}
        parseResult={parseResult}
        onUpdate={handleColumnUpdate}
      />

      <ColumnMappingEnumPanel
        fieldTitle={Locale.translate(Translation.TC_STATUS)}
        fieldName="tradingStatus"
        columnMapping={mapping.tradingStatus}
        parseResult={parseResult}
        Enum={EntityStatus}
        enumHelper={EntityStatusHelper}
        onUpdate={handleColumnUpdate}
      />
      <ColumnMappingStringPanel
        fieldTitle={Locale.translate(Translation.TC_LEI)}
        fieldName="lei"
        columnMapping={mapping.lei}
        parseResult={parseResult}
        onUpdate={handleColumnUpdate}
      />
      <ColumnMappingStringPanel
        fieldTitle={Locale.translate(Translation.TC_BIC)}
        fieldName="bic"
        columnMapping={mapping.bic}
        parseResult={parseResult}
        onUpdate={handleColumnUpdate}
      />
      <ColumnMappingEnumPanel
        fieldTitle={Locale.translate(Translation.TC_TRADING_TYPE)}
        fieldName="tradingEntityType"
        columnMapping={mapping.tradingEntityType}
        parseResult={parseResult}
        Enum={ExtendedTradingEntityType}
        enumHelper={TradingEntityTypeHelper}
        onUpdate={handleColumnUpdate}
      />
    </ColumnsContainer>
  )
}
